import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../components/header/header.component';
import { LanguageSwitcherModule } from 'src/core/components/language-switcher/modules/language-switcher.module';
import { WelcomeModule } from 'src/core/components/welcome/welcome.module';
import { CoreModule } from 'src/core/modules/core.Module';
import { TranslateModule } from '@ngx-translate/core';
import { UpdateUsernameService } from 'src/shared/services/updateUsername.service';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    CoreModule,
    LanguageSwitcherModule,
    WelcomeModule,
    TranslateModule
  ]
})
export class HeaderModule { }
